import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: ${theme.v3.spacing.xxs};
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0 ${theme.v3.spacing.md};
    width: 100%;
  `}
`;

export const Title = styled.h4`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: ${theme.v3.font.sizes.large};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
  `}
`;

export const HeaderInvoiceId = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[20]};
    gap: ${theme.v3.spacing.nano};
  `}
`;

export const List = styled.ul`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    gap: ${theme.v3.spacing.nano};
    padding: 0;
    margin: 0;
  `}
`;

export const ListItem = styled.li`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: ${theme.v3.spacing.xxs} ${theme.v3.spacing.xxxs};
    border: 1px solid ${theme.v3.colors.neutral[90]};
    border-radius: ${theme.v3.border.radius.md};
  `}
`;

export const ListItemNumber = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: ${theme.v3.spacing.quarck};
  `}
`;

export const ListItemNumberLabel = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.mini};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[60]};
  `}
`;

export const ListItemNumberCode = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[20]};
  `}
`;
